import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import About from "../components/About";
import InstagramTeaser from "../components/InstagramTeaser";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#0A0C10] text-white">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <InstagramTeaser />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
